<template>
    <comp-9-prep-adherence :section="9" :page="41" :nextDisabled="nextDisabled">
        <p>
            Review these ideas and strategies we hit on earlier. Consider a new idea or strategy that you didn’t check off the first time around.
        </p>
        <v-checkbox
            v-for="strategy in prepStrategies"
            :key="strategy.id"
            :label="strategy.text"
            :value="strategy.id"
            v-model="selectedStrategies"
            hide-details
            dense
        ></v-checkbox>
        <v-text-field v-if="showManualResponse" outline single-line type="text" v-model.trim="selectedStrategyResponse"></v-text-field>
    </comp-9-prep-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { filter, map, forEach } from 'lodash';

export default {
    data: function() {
        return {
            selectedStrategies: [],
            selectedStrategyResponse: null
        };
    },
    computed: {
        prepSelectedStrategies() {
            let prepSelectedStrategies = map(filter(this.prepStrategies, 'selected'), 'id');

            if (prepSelectedStrategies) {
                return prepSelectedStrategies;
            } else return [];
        },
        prepSelectedStrategyResponse() {
            let userEnteredStrategy = filter(filter(this.prepStrategies, 'selected'), 'userEntered');

            if (userEnteredStrategy.length > 0) {
                return userEnteredStrategy[0].response;
            }

            return null;
        },
        showManualResponse() {
            if (filter(filter(this.prepStrategies, 'selected'), 'userEntered').length > 0) {
                return true;
            }

            return false;
        },
        prepStrategies: sync('section9/prepRegularStrategiesRevisited')
    },
    methods: {
        nextDisabled() {
            if (this.selectedStrategies.length === 0 || (this.showManualResponse && !this.selectedStrategyResponse)) {
                return true;
            } else {
                return false;
            }
        }
    },
    watch: {
        selectedStrategies() {
            forEach(this.prepStrategies, o => {
                if (this.selectedStrategies.includes(o.id)) {
                    o.selected = true;

                    if (o.userEntered) {
                        o.response = this.selectedStrategyResponse;
                    }
                } else {
                    o.selected = false;

                    if (o.userEntered) {
                        o.response = null;
                    }
                }
            });
        },
        selectedStrategyResponse() {
            forEach(this.prepStrategies, o => {
                if (o.userEntered && o.selected) {
                    o.response = this.selectedStrategyResponse;
                }
            });
        }
    },
    mounted() {
        this.selectedStrategies = this.prepSelectedStrategies;
        this.selectedStrategyResponse = this.prepSelectedStrategyResponse;

        // if this is the first time visiting the screen, no items will be selected.
        // if that is the case, copy the strategies from the earlier version of this activity
        if (this.prepSelectedStrategies.length === 0) {
            let priorStrategies = this.$store.get('section9/prepRegularStrategies');

            forEach(priorStrategies, o => {
                if (o.selected) {
                    this.selectedStrategies.push(o.id);

                    if (o.userEntered) {
                        this.selectedStrategyResponse = o.response;
                    }
                }
            });
        }
    }
};
</script>
